import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from 'components/Tvendo/Common/ModalBase';
import TextField from '@material-ui/core/TextField';
import { wsGetAll } from 'services/WService';

export default function ModalPortfolio(props) {
  const portfolio = props.model;
  const [dataChanging, setDataChanging] = useState(portfolio);

  const [lines, setLines] = useState([]);
  const [businessPartners, setBusinessPartners] = useState([]);
  const [families, setFamilies] = useState([]);
  const [marks, setMarks] = useState([]);
  const [bureaus, setBureaus] = useState([]);

  async function listBusinessPartners() {
    let response = await wsGetAll('base/business-partner?CardType=S&QryGroup1=Y');
    if (response.success) setBusinessPartners(response.data);
  }

  async function listLines() {
    let response = await wsGetAll('logi/line');
    if (response.success) setLines(response.data);
  }

  async function listFamilies() {
    let response = await wsGetAll('logi/family');
    if (response.success) setFamilies(response.data);
  }

  async function listMarks(bbpId) {
    let response = await wsGetAll(
      `logi/mark?business_partners[]=${bbpId}`,
    );
    if (response.success) setMarks(response.data);
  }

  async function listBureaus() {
    let response = await wsGetAll('base/bureau');
    if (response.success) setBureaus(response.data);
  }

  function handleChange(field, value) {
    setDataChanging({
      ...dataChanging,
      [field]: value,
    });
  }

  useEffect(() => {
    if (portfolio.open) {
      listLines();
      listBusinessPartners();
      listFamilies();
      listBureaus();
    }
  }, [portfolio.open]);

  useEffect(() => {
    if (dataChanging?.base_business_partner_id === undefined) {
      setMarks([]);
      return;
    }
    // listMarks();
  }, [dataChanging.base_business_partner_id]);

  useEffect(() => {
    if (businessPartners.length > 0 && portfolio.base_business_partner_id) {
      handleChange("base_business_partner_id", String(portfolio.base_business_partner_id));
    }
  },[businessPartners]);

  useEffect(() => {
    if (marks.length > 0 && portfolio.logi_mark_id) {
      handleChange("logi_mark_id", String(portfolio.logi_mark_id));
    }
  }, [marks]);
  useEffect(() => {
    if (bureaus.length > 0 && portfolio.base_bureau_id) {
      handleChange("base_bureau_id", String(portfolio.base_bureau_id));
    }
  }, [bureaus]);

  useEffect(() => {
    if (dataChanging.base_business_partner_id !== null && dataChanging.base_business_partner_id !== undefined ) {
      listMarks(dataChanging.base_business_partner_id);
    }
  }, [dataChanging.base_business_partner_id]);

  return (
    <Modal
      title="Portafolio"
      model={portfolio}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="logi/portfolio"
      state
    >
      {/* <Autocomplete
        options={businessPartners}
        getOptionLabel={(option) => option.CardName}
        defaultValue={
          !!portfolio
            ? businessPartners.find(
                (businessP) => businessP.id == portfolio.base_business_partner_id,
              )
            : undefined
        }
        renderInput={(params) => (
          <TextField {...params} label="Socio de Negocio" margin="normal" required />
        )}
        onChange={(e, item) => {
          if (!!item) {
            return handleChange('base_business_partner_id', item.id);
          }
          handleChange('base_business_partner_id', null);
        }}
      /> */}

      <Autocomplete
        disableClearable
        options={businessPartners}
        getOptionLabel={(item) => `${item.CardName}`}
        renderInput={(params) => (
          <TextField {...params} label="Socio de Negocio" margin="normal" fullWidth />
        )}
        onChange={(e, item) => { handleChange('base_business_partner_id', item?.id);}}
        value={businessPartners.find((b) => String(b.id) === String(dataChanging.base_business_partner_id)) || null}
        style={{ flexGrow: 1, marginRight: '10px' }}
      />

      <Autocomplete
        options={lines}
        getOptionLabel={(option) => option.description}
        defaultValue={
          !!portfolio ? lines.find((line) => line.id == portfolio.logi_line_id) : undefined
        }
        renderInput={(params) => <TextField {...params} label="Línea" margin="normal" />}
        onChange={(e, item) => {
          if (!!item) {
            return handleChange('logi_line_id', item.id);
          }
          handleChange('logi_line_id', null);
        }}
      />

      <Autocomplete
        options={families}
        getOptionLabel={(option) => option.description}
        defaultValue={
          !!portfolio ? families.find((family) => family.id == portfolio.logi_family_id) : undefined
        }
        renderInput={(params) => <TextField {...params} label="Familia" margin="normal" />}
        onChange={(e, item) => {
          if (!!item) {
            return handleChange('logi_family_id', item.id);
          }
          handleChange('logi_family_id', null);
        }}
      />

      {/* <Autocomplete
        options={marks}
        getOptionLabel={(option) => option.description}
        defaultValue={
          !!portfolio ? marks.find((mark) => mark.id == portfolio.logi_mark_id) : undefined
        }
        renderInput={(params) => <TextField {...params} label="Marca" margin="normal" required />}
        onChange={(e, item) => {
          if (!!item) {
            return handleChange('logi_mark_id', item.id);
          }
          handleChange('logi_mark_id', null);
        }}
      /> */}
      <Autocomplete
        disableClearable
        options={marks}
        getOptionLabel={(item) => item.description}
        renderInput={(params) => (
          <TextField {...params} label="Marca" margin="normal" fullWidth />
        )}
        onChange={(e, item) => handleChange('logi_mark_id', item?.id)}
        value={marks.find((m) => String(m.id) === String(dataChanging.logi_mark_id)) || null}
        style={{ flexGrow: 1, marginRight: '10px' }}
      />
      {/* <Autocomplete
        options={bureaus}
        getOptionLabel={(option) => option.description}
        defaultValue={
          !!portfolio ? bureaus.find((bureau) => bureau.id == portfolio.base_bureau_id) : undefined
        }
        renderInput={(params) => <TextField {...params} label="Mesa" margin="normal" required />}
        onChange={(e, item) => {
          if (!!item) {
            return handleChange('base_bureau_id', item.id);
          }
          handleChange('base_bureau_id', null);
        }}
      /> */}

      <Autocomplete
        disableClearable
        options={bureaus}
        getOptionLabel={(item) => item.description}
        renderInput={(params) => (
          <TextField {...params} label="Mesa" margin="normal" fullWidth />
        )}
        onChange={(e, item) => handleChange('base_bureau_id', item?.id)}
        value={bureaus.find((m) => String(m.id) === String(dataChanging.base_bureau_id)) || null}
        style={{ flexGrow: 1, marginRight: '10px' }}
      />

      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Funcionalidad de detalle</InputLabel>
        <Select defaultValue={portfolio.detail_type || 'E'} inputProps={{ name: 'detail_type' }}>
          <MenuItem value="E">Excluir</MenuItem>
          <MenuItem value="I">Incluir</MenuItem>
        </Select>
      </FormControl>

      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Tipo detalle</InputLabel>
        <Select defaultValue={portfolio.item_type || 'P'} disabled>
          <MenuItem value="C">Categoría</MenuItem>
          <MenuItem value="L">Línea</MenuItem>
          <MenuItem value="F">Família</MenuItem>
          <MenuItem value="P">Producto</MenuItem>
        </Select>
      </FormControl>
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Retencion precio mayorista</InputLabel>
        <Select defaultValue={portfolio.mayorista_validation || 'Y'} inputProps={{ name: 'mayorista_validation' }}>
          <MenuItem value="Y">Aplicar</MenuItem>
          <MenuItem value="N">No aplicar</MenuItem>
        </Select>
      </FormControl>
    </Modal>
  );
}
